module.exports = __webpack_public_path__ + "img/activity-success-flow.0c0bd28c.png";